import * as React from 'react';
import { ICustomerMTAOptions } from '../../../../index';
import { IMtaState } from '../../../../../../../../services/mta/models';
import { winterSportsRule } from '../../MTAHelpers';
import { differenceInYears } from 'date-fns';
import { get } from 'lodash';
import { MTAChangeDetails } from '../MTAChangeDetails';

interface IMTAAddOptionsProps {
  customerMTAOptions: ICustomerMTAOptions,
  handleSelection: any,
  addedOptions: string[],
  optionKey: string,
  text: string,
  icon: string,
  mta: IMtaState,
}

export const MTAAddOptions = ({
                                customerMTAOptions,
                                handleSelection,
                                addedOptions,
                                optionKey,
                                text,
                                icon,
                                mta
                              }: IMTAAddOptionsProps) => {

  const isInCoolingOff = mta?.policyInfo?.meta?.isInCoolingOff || false;
  const schemeType = mta.selectedPolicy?.metadata?.scheme_type || '';
  const leadTraveller = mta.selectedPolicy?.metadata?.adults[0]

  // WS RULES
  if (schemeType === 'single') {
    if (!winterSportsRule(
      optionKey,
      new Date(mta?.selectedPolicy.metadata.start_date),
      new Date(mta?.selectedPolicy.metadata.end_date)
    )) {
      return null;
    }
  }

  if (optionKey === 'winter_sports' && get(mta, 'hasWinterSportsExclusion', false)) {
    return null;
  }

  const leadTravellerAge = differenceInYears(new Date(), leadTraveller?.dob);
  if (leadTraveller?.dob && leadTravellerAge > 65 && optionKey === 'winter_sports') {
    return null;
  }

  // EXCESS WAIVER RULES
  if (optionKey === 'excess_waiver' && !isInCoolingOff) {
    return null;
  }

  let optionAlreadyAdded = false;

  if (addedOptions.length && addedOptions.includes(optionKey)) {
    optionAlreadyAdded = true;
  }

  if (customerMTAOptions?.additional_options?.enabled && !optionAlreadyAdded) {
    return (
      <>
        <MTAChangeDetails
          text={text}
          icon={icon}
          handleClick={handleSelection}
        />
      </>
    )
  }

  return null;

}
